export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11925.f6f79fda.jpg";